import React, { useEffect, useRef, useState } from 'react';
import '../../../assets/css/accounts.scss';
import AppNavbar from '../../Navbar/AppNavbar';
import Footer from '../../Navbar/Footer';
import { Badge, Button, Card, Col, ProgressBar, Row, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { loadCreditUsage, loadCurrentPlan } from '../../redux/accountsService/ac_action';
import { Skeleton } from '@mui/material';
import { loadProfileData } from '../../redux/action';
import { useNavigate } from 'react-router-dom';
import { capitalizeFirstLetter } from '../../CommonFile/Function_utils';

const AccountPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const signInID = signInDetails[0]?.id;

    const hasRun = useRef();
    const { getCredits } = useSelector(state => state.data);
    const { currentPlan } = useSelector(state => state.acntdata);
    const { creditUsage } = useSelector(state => state.acntdata);
    const { profileData } = useSelector((state) => state.data);

    const [loading, setLoading] = useState(false);

    const planBadge = (plan) => {
        switch (plan) {
            case "Free":
                return "free";
            case "Pro":
                return "pro";
            default:
                return "business";
        }
    };

    useEffect(() => {
        dispatch(loadCreditUsage())
        dispatch(loadProfileData(signInID, setLoading))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (Object.keys(getCredits).length > 0) {
            if (hasRun.current) return;
            dispatch(loadCurrentPlan(getCredits?.current_plan, getCredits?.plan_type));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getCredits])

    const isDataTrue = Object.keys(getCredits).length > 0 ? true : false;
    const isUsagedataTrue = Object.keys(creditUsage).length > 0 ? true : false;

    console.log(getCredits, "getCredits")


    const allow_members = isDataTrue ? currentPlan?.users_allowed : 0;

    const usedPercent = isDataTrue ? Math.round(
        (Number(getCredits?.used_credit) / Number(getCredits?.purchased_credit)) * 100
    ) : 0;

    const navigateToUpgrade = () => {
        navigate("/upgrade_plan")
    }

    return (
        <div className='page-layout'>
            <AppNavbar />
            <div className='page-content' style={{ overflow: "auto" }}>
                <div className="subscription-wrapper">
                    <Row className='m-0'>
                        <Col md={6}>
                            <Card className="subscription-card shadow-sm">
                                <Card.Body>

                                    <div className="subscription-header d-flex justify-content-between">

                                        <div className='text-start'>
                                            <div className="d-flex align-items-center gap-2">

                                                <h4 className='d-flex align-items-center'>{isDataTrue ? capitalizeFirstLetter(getCredits?.current_plan) : <Skeleton circle={true} height={25} width={100} />} Plan</h4>

                                                <span className="status-pill">
                                                    Active
                                                </span>

                                            </div>

                                            <p className="renew-text d-flex align-items-center">
                                                Ends on {isDataTrue ? moment(getCredits?.end_date).format("MMM DD, YYYY") : <Skeleton circle={true} height={25} width={100} />}
                                            </p>

                                            <small className='d-flex align-items-center'>
                                                Your subscription Will be ends automatically on {isDataTrue ? moment(getCredits?.end_date).format("MMM DD, YYYY") : <Skeleton circle={true} height={25} width={100} />}.
                                            </small>

                                        </div>

                                        <div className="d-flex gap-2">

                                            {/* <Button variant="outline-light">
                                                Manage Plan
                                            </Button> */}

                                            <Button variant="warning" onClick={navigateToUpgrade}>
                                                Upgrade
                                            </Button>

                                        </div>

                                    </div>

                                    <hr />

                                    <div className="plan-table">

                                        <div className="plan-row">
                                            <div className='text-start'>
                                                <h6>👥 Seats</h6>
                                                <p>{allow_members} Team Members</p>
                                                {/* <a href="">+ Add teammates</a> */}
                                            </div>

                                            <div className='d-flex align-items-center'>${isDataTrue ? currentPlan?.price : <Skeleton circle={true} height={25} width={100} />}/mo</div>
                                        </div>

                                        <div className="plan-row">
                                            <div className='text-start'>
                                                <h6>⚡ Credits</h6>
                                                <p className='d-flex align-items-center'>{isDataTrue ? currentPlan?.total_credits : <Skeleton circle={true} height={25} width={100} />} Credits / Month</p>
                                            </div>

                                            <div>Included</div>
                                        </div>

                                        <div className="plan-row">
                                            <div style={{ textAlign: "left" }}>
                                                <h6>🎁 Bonus Credits</h6>
                                                <p>0 Bonus Credits</p>
                                                {/* <a href="#">+ Buy more credits</a> */}
                                            </div>

                                            {/* <div>Free</div> */}
                                        </div>

                                    </div>

                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card className="credit-card">

                                <Card.Body>

                                    <div className="credit-header">

                                        <div className='text-start'>

                                            <h4>Credit Usage</h4>

                                            <span className='d-flex align-items-center'>{isDataTrue ? moment(getCredits?.start_date).format("MMM DD, YYYY") : <Skeleton circle={true} height={25} width={100} />} - {isDataTrue ? moment(getCredits?.end_date).format("MMM DD, YYYY") : <Skeleton circle={true} height={25} width={100} />}</span>

                                            {/* <a href="">View Usage History</a> */}

                                        </div>

                                        <div className="text-end">

                                            <small>Next Reset</small>

                                            <h6 className='d-flex align-items-center'>{isDataTrue ? moment(getCredits?.end_date).add(1, "day").format("MMM DD, YYYY") : <Skeleton circle={true} height={25} width={100} />}</h6>

                                        </div>

                                    </div>

                                    <hr />

                                    <div className="credit-content">

                                        {/* <div className="credit-icon">

                                            <i className="bx bx-coin-stack"></i>

                                        </div> */}

                                        {/* <h5>Credits Used</h5> */}

                                        <div className="credit-number">

                                            <span className='d-flex align-items-center'>{isDataTrue ? getCredits?.used_credit.toString() : <Skeleton circle={true} height={25} width={100} />}</span>

                                            <small className='d-flex align-items-center'>/ {isUsagedataTrue ? creditUsage?.credits_aval.toString() : <Skeleton circle={true} height={25} width={100} />} Credits</small>

                                            <label>{usedPercent}% Used</label>

                                        </div>

                                        <ProgressBar
                                            now={usedPercent}
                                            className="credit-progress"
                                        />

                                        <p><b>Overall credit usage</b></p>
                                        <div className="credit-breakdown">

                                            <div className="credit-item">
                                                <div className="credit-item-icon">
                                                    <i className="bx bx-envelope"></i>
                                                </div>
                                                <div>
                                                    <h6>Email</h6>
                                                    <span className='d-flex align-items-center'>{isUsagedataTrue ? creditUsage?.email_consume : <Skeleton circle={true} height={25} width={60} />}</span>
                                                </div>
                                            </div>

                                            <div className="credit-item">
                                                <div className="credit-item-icon">
                                                    <i className="bx bx-phone"></i>
                                                </div>
                                                <div>
                                                    <h6>Phone</h6>
                                                    <span className='d-flex align-items-center'>{isUsagedataTrue ? creditUsage?.phone_consume : <Skeleton circle={true} height={25} width={60} />}</span>
                                                </div>
                                            </div>

                                            <div className="credit-item">
                                                <div className="credit-item-icon">
                                                    <i className="bx bx-bot"></i>
                                                </div>
                                                <div>
                                                    <h6>AI</h6>
                                                    <span className='d-flex align-items-center'>{isUsagedataTrue ? creditUsage?.ai_consume : <Skeleton circle={true} height={25} width={60} />}</span>
                                                </div>
                                            </div>

                                        </div>

                                        <div className="credit-footer">

                                            <div className='text-start'>

                                                <strong>{isDataTrue ? getCredits?.credits_aval.toString() : <Skeleton circle={true} height={25} width={100} />} Credits Remaining</strong>

                                                <p>
                                                    Credits are used for email unlocks,
                                                    mobile numbers and enrichment.
                                                </p>

                                            </div>

                                            {/* <Button variant="warning">

                                                Buy Credits

                                            </Button> */}

                                        </div>

                                    </div>

                                </Card.Body>

                            </Card>
                        </Col>
                    </Row>
                    <Row className='m-0'>
                        <Col md={12}>
                            <Card className="subscription-table-card">

                                <Card.Body>

                                    <div className="table-header">

                                        <div>
                                            <h4>Subscription Details</h4>
                                            <p>Manage all your subscription plans.</p>
                                        </div>

                                        <Button variant="warning" onClick={navigateToUpgrade}>
                                            Change Plan
                                        </Button>

                                    </div>

                                    <div className="table-responsive">

                                        <Table hover className="subscription-table">

                                            <thead>

                                                <tr>

                                                    <th>Item Name</th>
                                                    <th>Plan</th>
                                                    <th>Quantity</th>
                                                    <th>Subscription Period</th>
                                                    <th>Credits</th>
                                                    <th>Status</th>
                                                    {/* <th>Action</th> */}

                                                </tr>

                                            </thead>

                                            <tbody>

                                                {profileData?.purchased_items?.length > 0 ? profileData?.purchased_items.map((item, index) => (

                                                    <tr key={index}>

                                                        <td>
                                                            <div className="item-name">
                                                                <i className='bx bx-package'></i>
                                                                <div>
                                                                    <strong>{item.item_name}</strong>
                                                                    <small>Email & Mobile Enrichment</small>
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <span className={`plan-badge ${planBadge(item.plan)}`}>
                                                                {item.plan}
                                                            </span>
                                                        </td>

                                                        <td>{item.quantity}</td>

                                                        <td>{item.subscription_period}</td>

                                                        <td>
                                                            <span className="credit">
                                                                <i className='bx bx-coin-stack'></i>
                                                                {item.Credits}
                                                            </span>
                                                        </td>

                                                        <td>

                                                            <Badge bg={index === 0 ? "success" : "secondary"}>
                                                                {index === 0 ? "Active" : "Expired"}
                                                            </Badge>

                                                        </td>

                                                        {/* <td>

                                                            <Button size="sm" variant="light">
                                                                <i className='bx bx-show'></i>
                                                            </Button>

                                                        </td> */}

                                                    </tr>

                                                )) : ""}

                                            </tbody>

                                        </Table>

                                    </div>

                                </Card.Body>

                            </Card>
                        </Col>
                    </Row>
                </div>
            </div >
            <Footer />
        </div >
    );
};

export default AccountPage;